/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import ActivityFeed from "@/components/ActivityFeed";

export default function JournalPage() {
  const [events, setEvents] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const load = useCallback(async () => {
    try {
      const [ev, tr] = await Promise.all([
        api.get("/events", { params: { limit: 200 } }),
        api.get("/trainers"),
      ]);
      setEvents(ev.data);
      setTrainers(tr.data);
    } catch { /* ignore */ }
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [load]);

  return (
    <div data-testid="journal-page">
      <div className="overline">Archives · Machine à écrire</div>
      <h1 className="font-serif-display text-4xl md:text-5xl leading-none mt-1 mb-4">Journal</h1>
      <div className="panel p-0">
        <div className="max-h-[calc(100vh-220px)] overflow-auto">
          <ActivityFeed events={events} trainers={trainers}/>
        </div>
      </div>
    </div>
  );
}
